// @flow

import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
	mutation UserEditMutation($input: UserEditInput!) {
		UserEdit(input: $input) {
            error
			user {
                id
                name
			}
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation,
		variables: {
			input: params,
		},
		onCompleted: response => {
			const {error, user} = response.UserEdit;
			if (error) {
				callback(error, null);
				return;
			}

			callback(null, user);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/UserEditMutation.js